export const APP_NAME = 'Pastità';

// Navigation items for header
export const NAV_ITEMS = [
    {id: 'menu', label: 'Menu'},
    {id: 'how-it-works', label: 'Come funziona'},
    {id: 'subscription', label: 'Abbonamenti'},
    {id: 'where-we-are', label: 'Dove siamo'},
    {id: 'contact', label: 'Contatti'}
];

// URLs for images
export const IMAGES = {
    LOGO_BLACK: '/logo_nero.png',
    LOGO_WHITE: '/logo_bianco.png',
    HERO_IMAGE: '/hero_image.png'
};

// Form configuration
export const FORM_CONFIG = {
    CONTACT_FORM: {
        FIELDS: {
            NAME: 'name',
            EMAIL: 'email',
            MESSAGE: 'message'
        }
    }
};

// Section IDs
export const SECTION_IDS = {
    MENU: 'menu',
    HOW_IT_WORKS: 'how-it-works',
    SIMULATOR: 'simulatore',
    SUBSCRIPTION: 'subscription',
    WHERE_WE_ARE: 'where-we-are',
    CONTACT: 'contact'
};


export const MAP_IFRAME = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2798.854587066735!2d9.185768776537515!3d45.46533623566306!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4786c6aec34636a1%3A0xab7f4e27101a2e19!2sMilano%20MI!5e0!3m2!1sit!2sit!4v1698765432123!5m2!1sit!2sit";
export const MAP_ADDRESS = 'https://maps.google.com/?q=Milano,Via+Roma+123';

export const WHERE_WE_ARE_INFO = {
    address: 'Via Roma, 123, 20100 Milano, MI',
    time: {
        weekdays: 'Lunedì - Venerdì: 11:00 - 22:00',
        weekend: 'Sabato - Domenica: 12:00 - 23:00'
    },
    contacts: {
        phone: '+39 02 1234567',
        email: 'info@pastita.it',
    }
};
